var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserPanel6White(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.6 263.65C236.056 242.196 219.033 224.435 197.579 223.979C176.125 223.523 158.363 240.545 157.907 261.999C157.452 283.454 174.474 301.215 195.928 301.671C217.382 302.127 235.144 285.104 235.6 263.65Z",
    fill: "#bebebe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.749 308.151C152.465 308.569 116.953 339.485 116.953 377.503L277.382 376.249C276.964 338.231 241.034 307.733 196.749 308.151Z",
    fill: "#bebebe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M790.001 458.547H13.3438V535.001H790.001V458.547Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M790.001 64.998H13.3438V141.452H790.001V64.998Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.168 409.248H10V182.811H385.168V409.248ZM16.2667 402.982H378.902V189.077H16.2667V402.982Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M789.583 181.979H401.463V202.032H789.583V181.979Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M789.583 232.943H401.463V252.997H789.583V232.943Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M789.583 283.918H401.463V303.972H789.583V283.918Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M789.583 334.885H401.463V354.939H789.583V334.885Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M789.583 385.859H401.463V405.912H789.583V385.859Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPanel6White);
export default __webpack_public_path__ + "static/media/user-panel-6-white.3fa8de44d959f8f6748ccb93dfeb014f.svg";
export { ForwardRef as ReactComponent };